// hooks/usePolling.js
import { useEffect, useRef } from "react";

export interface UsePollingProps {
  callback: () => any;
  delay?: number;
  isActive?: boolean;
}

export const usePolling = ({
  callback,
  delay = 30000,
  isActive = true,
}: UsePollingProps) => {
  const savedCallback = useRef(callback);
  const isLatestRef = useRef(true);

  // Actualizar callback sin reiniciar el intervalo
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!isActive) return;

    isLatestRef.current = true;

    const interval = setInterval(() => {
      if (document.visibilityState === "visible" && isLatestRef.current) {
        savedCallback.current();
      }
    }, delay);

    return () => {
      clearInterval(interval);
      isLatestRef.current = false;
    };
  }, [delay, isActive]);
};
